import React, { Component } from "react";
import { Modal, Button, Form, Row, Col, Tabs, Tab, InputGroup } from "react-bootstrap";
import ToggleButton from "react-toggle-button";
import { connect } from "react-redux";
import t from "../../Actions/CloudVpcActions/type";
import * as CloudVpcActions from "../../Actions/CloudVpcActions/actions";
import getPropertyId from "../../Utils/getPropertyId";
import { get_all_lots } from "../../Actions/SuperAdminAction/actions";


class AddCloudVpcModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        server: "",
        property_id: "",
        lot_id: "",
        mac_id: "",
        public_ip: "",
        public_ip_port: "",
        camera_user: "",
        camera_pass: "",
        approach_ip: "",
        away_ip: "",
        default_direction: "",
        key: "",
        vend: 0,
        vend_ip: "",
        vend_port: "",
        active: 1,
        permit_sync: 0,
        vend_whitelist: 0,
        vend_relay: 0,
        showPassword: false,
      },
      errors: {},
    };
  }

  // Add this toggle method to your component
  togglePasswordVisibility = () => {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  };

  componentDidMount() {
    // 1. If Editing: Populate form with existing data
    if (!this.props.isCreateMode && this.props.selectedVpc) {
      this.setState({ formData: { ...this.props.selectedVpc } }, () => {
        // Fetch lots for the existing property ID in edit mode
        if (this.state.formData.property_id) {
          this.props.get_all_lots(this.state.formData.property_id);
        }
      });
      return;
    }

    // For create mode, prefer the passed `propertyId`, otherwise try the URL query string
    if (this.props.isCreateMode) {
      let propId = this.props.propertyId;
      if (!propId) {
        try {
          const params = new URLSearchParams(window.location.search || "");
          propId = params.get("propertyId") || params.get("property") || params.get("id");
          // If URL is like ?<uuid> (no key), try using the raw query string as the id
          if (!propId) {
            const search = (window.location.search || "").trim();
            if (search && search.startsWith("?") && !search.includes("=")) {
              propId = search.substring(1);
            }
          }
        } catch (e) {
          propId = null;
        }
      }

      if (propId) {
        this.setState((prev) => ({ formData: { ...prev.formData, property_id: propId } }));
        // ensure lots are loaded for this property so the select can populate
        const { get_all_lots, lots } = this.props;
        const lotsPresent = (Array.isArray(lots) && lots.length) || (Array.isArray(get_all_lots) && get_all_lots.length);
        if (!lotsPresent) {
          // fetch lots silently for the given property
          // debug: log intent then dispatch
          // eslint-disable-next-line no-console
          console.debug("AddCloudVpcModal: fetching lots for property", propId);
          let x = this.props.get_all_lots(propId, "", false, true);
          console.log("AddCloudVpcModal: get_all_lots returned", x);
          // log state shortly after dispatch to help debugging
          setTimeout(() => {
            // eslint-disable-next-line no-console
            console.debug("AddCloudVpcModal: after fetch lots / paginated:", this.props.lots, this.props.get_all_lots);
          }, 600);
        }
      }
    }
  }

  handleClose = () => {
    this.props.dispatch({ type: t.CLOSE_OPEN_MODEL, payload: false });
  };

  validate = () => {
    const { formData } = this.state;
    let errors = {};
    const ipRegex = /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/;
    const macRegex = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/;

    // Required fields
    if (!formData.mac_id || !macRegex.test(formData.mac_id)) errors.mac_id = "Invalid MAC format";
    if (!formData.public_ip || !ipRegex.test(formData.public_ip)) errors.public_ip = "Invalid IP";
    if (!formData.approach_ip || !ipRegex.test(formData.approach_ip)) errors.approach_ip = "Invalid IP";
    if (!formData.away_ip || !ipRegex.test(formData.away_ip)) errors.away_ip = "Invalid IP";
    if (!formData.key) errors.key = "Key is required";

    // Optional but if provided must be valid
    if (formData.public_ip_port && (!/^\d+$/.test(formData.public_ip_port) || Number(formData.public_ip_port) < 1 || Number(formData.public_ip_port) > 65535)) {
      errors.public_ip_port = "Invalid port (1-65535)";
    }

    // Vend validations: only validate vend ip/port if vend is enabled
    if (formData.vend === 1) {
      if (!formData.vend_ip || !ipRegex.test(formData.vend_ip)) errors.vend_ip = "Invalid Vend IP";
      if (!formData.vend_port || !/^\d+$/.test(formData.vend_port) || Number(formData.vend_port) < 1 || Number(formData.vend_port) > 65535)
        errors.vend_port = "Invalid Vend port";
    }

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: type === "checkbox" ? (checked ? 1 : 0) : value,
      },
    }));
  };

  handleSubmit = () => {
    if (this.validate()) {
      if (this.props.isCreateMode) {
        this.props.dispatch(CloudVpcActions.addCloudVpc(this.state.formData));
      } else {
        this.props.dispatch(CloudVpcActions.editCloudVpc(this.state.formData));
      }
      this.handleClose();
    }
  };

  render() {
    const { formData, errors } = this.state;
    const { isCreateMode, getAllLotsPaginated, propertyId, lots } = this.props;
    const lotList = Array.isArray(lots) ? lots : [];

    // Compute current property id from props, URL (supports ?id or ?key=value), or state
    const currentPropertyId = getPropertyId(this.props) || this.state.formData.property_id || null;

    // Use `lots` (non-paginated, populated by get_all_lots); fall back to `getAllLotsPaginated` if empty
    const lotsSource = Array.isArray(lots) && lots.length ? lots : getAllLotsPaginated || [];
    const lotsForProperty = (lotsSource || []).filter((lot) => {
      const lotProperty = lot.property_id || lot.propertyId || lot.property || "";
      return currentPropertyId ? String(lotProperty) === String(currentPropertyId) : true;
    });

    return (
      <Modal show={this.props.show} onHide={this.handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>{isCreateMode ? "Add New VPC Device" : "Edit VPC Configuration"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Tabs defaultActiveKey="device-info" id="vpc-device-tabs" className="mb-3">
              {/* Tab 1: Device Information */}
              <Tab eventKey="device-info" title="Device Info">
                <div className="p-3">
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>MAC ID</Form.Label>
                        <Form.Control
                          name="mac_id"
                          value={formData.mac_id}
                          onChange={this.handleChange}
                          isInvalid={!!errors.mac_id}
                          placeholder="00:1A:2B:3C:4D:5E"
                        />
                        <Form.Control.Feedback type="invalid">{errors.mac_id}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Server</Form.Label>
                        <Form.Control name="server" value={formData.server} onChange={this.handleChange} placeholder="Server name" />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Device Key</Form.Label>
                        <Form.Control name="key" value={formData.key} onChange={this.handleChange} isInvalid={!!errors.key} placeholder="Enter device key" />
                        <Form.Control.Feedback type="invalid">{errors.key}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Assigned Lot</Form.Label>
                        <Form.Control as="select" name="lot_id" value={formData.lot_id} onChange={this.handleChange} isInvalid={!!errors.lot_id}>
                          <option value="">Select a lot</option>
                          {lotList.map((lot) => (
                            <option key={lot.id} value={lot.id}>
                              {lot.alias || lot.name || `Lot ${lot.id}`}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors.lot_id}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Default Direction</Form.Label>
                        <Form.Control
                          as="select"
                          name="default_direction"
                          value={formData.default_direction}
                          onChange={this.handleChange}
                          aria-label="Select Default Direction"
                        >
                          <option value="">Select direction</option>
                          <option value="approach">Approach</option>
                          <option value="away">Away</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </Tab>

              {/* Tab 2: Network Configuration */}
              <Tab eventKey="network-config" title="Network Config">
                <div className="p-3">
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Public IP</Form.Label>
                        <Form.Control
                          name="public_ip"
                          value={formData.public_ip}
                          onChange={this.handleChange}
                          isInvalid={!!errors.public_ip}
                          placeholder="192.168.1.1"
                        />
                        <Form.Control.Feedback type="invalid">{errors.public_ip}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Public IP Port</Form.Label>
                        <Form.Control
                          name="public_ip_port"
                          value={formData.public_ip_port}
                          onChange={this.handleChange}
                          isInvalid={!!errors.public_ip_port}
                          placeholder="8080 (optional)"
                        />
                        <Form.Control.Feedback type="invalid">{errors.public_ip_port}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Approach IP</Form.Label>
                        <Form.Control
                          name="approach_ip"
                          value={formData.approach_ip}
                          onChange={this.handleChange}
                          isInvalid={!!errors.approach_ip}
                          placeholder="192.168.1.2"
                        />
                        <Form.Control.Feedback type="invalid">{errors.approach_ip}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Away IP</Form.Label>
                        <Form.Control
                          name="away_ip"
                          value={formData.away_ip}
                          onChange={this.handleChange}
                          isInvalid={!!errors.away_ip}
                          placeholder="192.168.1.3"
                        />
                        <Form.Control.Feedback type="invalid">{errors.away_ip}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Vend IP</Form.Label>
                        <Form.Control
                          name="vend_ip"
                          value={formData.vend_ip}
                          onChange={this.handleChange}
                          isInvalid={!!errors.vend_ip}
                          placeholder="192.168.1.4 (if Vend enabled)"
                        />
                        <Form.Control.Feedback type="invalid">{errors.vend_ip}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Vend Port</Form.Label>
                        <Form.Control
                          name="vend_port"
                          value={formData.vend_port}
                          onChange={this.handleChange}
                          isInvalid={!!errors.vend_port}
                          placeholder="1-65535 (if Vend enabled)"
                        />
                        <Form.Control.Feedback type="invalid">{errors.vend_port}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </Tab>

              {/* Tab 3: Camera & Configuration */}
              <Tab eventKey="camera-config" title="Camera & Flags">
                <div className="p-3">
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Camera User</Form.Label>
                        <Form.Control name="camera_user" value={formData.camera_user} onChange={this.handleChange} placeholder="Username (optional)" />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Camera Password</Form.Label>
                        {/* Use InputGroup to attach the button to the input */}
                        <InputGroup>
                          <Form.Control
                            name="camera_pass"
                            value={formData.camera_pass}
                            onChange={this.handleChange}
                            // Toggle the type based on state
                            type={this.state.showPassword ? "text" : "password"}
                            placeholder="Password (optional)"
                          />
                          <button className="mask-password" type="button" onClick={this.togglePasswordVisibility}>
                            {this.state.showPassword ? <i className="fas fa-eye"></i> : <i className="fas fa-eye-slash"></i>}
                          </button>
                        </InputGroup>
                      </Form.Group>
                    </Col>
                  </Row>

                  <hr />

                  <Row className="mb-3">
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Active</Form.Label>
                        <div className="d-flex align-items-center">
                          <ToggleButton
                            value={formData.active === 1}
                            onToggle={(val) => this.handleChange({ target: { name: "active", type: "checkbox", checked: !val } })}
                          />
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Vend</Form.Label>
                        <div className="d-flex align-items-center">
                          <ToggleButton
                            value={formData.vend === 1}
                            onToggle={(val) => this.handleChange({ target: { name: "vend", type: "checkbox", checked: !val } })}
                          />
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Permit Sync</Form.Label>
                        <div className="d-flex align-items-center">
                          <ToggleButton
                            value={formData.permit_sync === 1}
                            onToggle={(val) => this.handleChange({ target: { name: "permit_sync", type: "checkbox", checked: !val } })}
                          />
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Vend for Whitelist</Form.Label>
                        <div className="d-flex align-items-center">
                          <ToggleButton
                            value={formData.vend_whitelist === 1}
                            onToggle={(val) => this.handleChange({ target: { name: "vend_whitelist", type: "checkbox", checked: !val } })}
                          />
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Vend Relay</Form.Label>
                        <div className="d-flex align-items-center">
                          <ToggleButton
                            value={formData.vend_relay === 1}
                            onToggle={(val) => this.handleChange({ target: { name: "vend_relay", type: "checkbox", checked: !val } })}
                          />
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </Tab>
            </Tabs>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={this.handleSubmit}>
            {isCreateMode ? "Save Device" : "Update Changes"}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}


const mapStateToProps = (state) => ({
  isCreateMode: state.CloudVpcDetails.isCreateMode,
  selectedVpc: state.CloudVpcDetails.selectedVpc,
  getAllLotsPaginated: state.SuperAdminDetails.getAllLotsPaginated,
  lots: state.SuperAdminDetails.lots,
});
const mapStateToDispatch = (dispatch) => ({
  dispatch,
  get_all_lots: (propertyId) => dispatch(get_all_lots(propertyId)),
});


export default connect(mapStateToProps, mapStateToDispatch)(AddCloudVpcModal);



